import type { AxiosResponse } from 'axios';

import { getCurrentCustomer } from '@/modules/perseo-billing/store/user/user.reducer';
import { clientWindow } from '@/modules/perseo-billing/utils/window';

// TODO: replace with new relic's browser monitoring agent
const newrelic = clientWindow.newrelic;

export interface IInfoRequest {
  message?: string;
  status?: number;
  statusText?: string;
  url: string;
  method: string;
  params: string;
}

export const HTTP_RESPONSE_LABEL = 'Http Response';

// TODO: add strong types
/* eslint-disable @typescript-eslint/no-explicit-any */
export const notifyError = (err: any) => {
  newrelic?.log(err);
};

export const notifyLogger = (err: any) => {
  newrelic?.noticeError(err);
};

/* eslint-disable @typescript-eslint/no-explicit-any */
export const addPageAction = (action: any, value?: any) => {
  if (value) {
    newrelic?.addPageAction(action, value);
  } else {
    newrelic?.addPageAction(action);
  }
};

export const addPageActionResponse = (
  action: string,
  response: AxiosResponse
) => {
  const responseTemp: IInfoRequest = {
    status: response?.status,
    statusText: response?.statusText,
    url: response?.config?.url || '',
    method: response?.config?.method || '',
    params: response?.config?.params
  };
  addPageAction(action, responseTemp);
};

/* eslint-disable @typescript-eslint/no-explicit-any */
export const addPageActionResponseError = (
  action: string,
  infoRequest: IInfoRequest,
  error: any
) => {
  infoRequest.status = error?.response?.status;
  infoRequest.statusText = error?.name;
  infoRequest.message = error?.message;
  addPageAction(action, infoRequest);
};

export const setCustomAtr = (name: string, value: string | number) => {
  newrelic?.setCustomAttribute(name, value);
};

export const setCustomAtrUser = () => {
  const userId: string | number =
    getCurrentCustomer()?.identificationValue || '';
  const sessionId: string | number = getCurrentCustomer()?.sessionId || '';
  newrelic?.setCustomAttribute('userId', userId);
  newrelic?.setCustomAttribute('sessionId', sessionId);
};

/* eslint-disable @typescript-eslint/no-explicit-any */
export const interactionSetAtr = (name: string, value: any) => {
  newrelic?.interaction().setAttribute(name, value);
};
